import { render, staticRenderFns } from "./partner-rate-modal.vue?vue&type=template&id=2dcaff96&"
import script from "./partner-rate-modal.vue?vue&type=script&lang=js&"
export * from "./partner-rate-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports